import { RadioButtonValgModel } from '../../Shared/Scripts/Components/RadioButtonValg';
import VeilederHounDto from '../Models/VeilederHounDto';

const borte = 'd1-borte';
const hjemme = 'd2-hjemme';

const dValg: RadioButtonValgModel<VeilederHounDto>[] = [
    { id: 'd1', value: borte, tekst: 'valgBorForMegSelv' },
    {
        id: 'd2',
        value: hjemme,
        tekst: 'valgBorMedForeldre',
    },
];

export default {
    d1_hjemme: hjemme,
    d2_borte: borte,
    dValg,
};
